import type { JSX } from 'react';
import classes from './loading-indicator.module.css';

interface LoadingIndicatorProps {
  dotColor?: string;
  sizePx?: number;
}

export default function LoadingIndicator({ dotColor = '#bec6d0', sizePx = 10 }: LoadingIndicatorProps): JSX.Element {
  const groupStyles = {
    gap: `${Math.floor(sizePx * 0.8).toString()}px`,
  };

  const dotStyles = {
    backgroundColor: dotColor,
    height: `${sizePx.toString()}px`,
    width: `${sizePx.toString()}px`,
  };

  return (
    <div
      className={classes['loading-indicator']}
      style={groupStyles}
    >
      <div
        className={classes['loading-indicator__dot']}
        style={dotStyles}
      />
      <div
        className={classes['loading-indicator__dot']}
        style={dotStyles}
      />
      <div
        className={classes['loading-indicator__dot']}
        style={dotStyles}
      />
    </div>
  );
}
